import type { CheckMonitorResponse } from 'types/checkMonitor';

// At least 3.5:1 against both the light and dark chart surfaces.
const colors = [
  '#2f87c6',
  '#bc6c13',
  '#9d6bc4',
  '#159286',
  '#ce5a86',
  '#718a3e',
];
const dashes = ['', '7 3', '2 3', '9 3 2 3'];
export const seriesStyle = (serial: string) => {
  const hash = Array.from(serial).reduce(
    (value, char) => (value * 31 + char.charCodeAt(0)) >>> 0,
    0
  );
  return {
    color: colors[hash % colors.length],
    marker: hash % 4,
    dash: dashes[Math.floor(hash / 4) % dashes.length],
  };
};
export const labelledDevices = (data: CheckMonitorResponse) => {
  const names = data.devices.map(
    (device) =>
      device.tags.find((tag) => tag.tagName.trim())?.tagName.trim() || ''
  );
  return data.devices.map((device, index) => ({
    ...device,
    label: !names[index]
      ? device.serialNumber
      : names.filter((name) => name === names[index]).length > 1
        ? `${names[index]} (${device.serialNumber})`
        : names[index],
    ...seriesStyle(device.serialNumber),
    counts:
      data.series.find((series) => series.serialNumber === device.serialNumber)
        ?.counts || [],
  }));
};
export type MonitorDevice = ReturnType<typeof labelledDevices>[number];
